import api from "@/services/api";
/****************
 * Collections
 ****************/

export default {
  getCollections() {
    return api.get(`/api/v1/collections`);
  },

  getCollection(collection) {
    return api.get(`/api/v1/collection`, collection);
  },

  updateCollection(collectionId, data) {
    return api.put(`/api/v1/collection?id=${collectionId}`, data);
  },

  deleteCollection(collectionId) {
    return api.delete(`/api/v1/collection?id=${collectionId}`);
  },

  async getCollectionFields(workspaceId, appId, collectionId) {
    if (!workspaceId || !appId || !collectionId) {
      throw new Error("Invalid parameters provided.");
    }

    const response = await api.get(
      `/api/v1/workspace/${workspaceId}/app/${appId}/data/${collectionId}/columns`
    );

    return response.data.data;
  }
};
